import { RepaymentResult } from "./types";

function roundToTwo(value: number): number {
  return Math.round(value * 100) / 100;
}

export function calculateRepayment(
  principal: number,
  annualInterestRate = 0.05,
  months = 120
): RepaymentResult {
  if (principal <= 0) {
    return {
      principal: 0,
      monthlyPayment: 0,
      monthsToRepay: 0,
      totalPaid: 0,
    };
  }

  if (months <= 0) {
    throw new Error("months must be greater than 0");
  }

  const monthlyRate = annualInterestRate / 12;

  if (monthlyRate === 0) {
    const monthlyPayment = principal / months;

    return {
      principal: roundToTwo(principal),
      monthlyPayment: roundToTwo(monthlyPayment),
      monthsToRepay: months,
      totalPaid: roundToTwo(monthlyPayment * months),
    };
  }

  const monthlyPayment =
    (principal * monthlyRate) /
    (1 - Math.pow(1 + monthlyRate, -months));

  const totalPaid = monthlyPayment * months;

  return {
    principal: roundToTwo(principal),
    monthlyPayment: roundToTwo(monthlyPayment),
    monthsToRepay: months,
    totalPaid: roundToTwo(totalPaid),
  };
}